import { IAuthenticationProvider, AuthEnvironment } from "./interfaces/IAuthenticationProvider"
import { PpeAuthenticationProvider } from './office-js/auth/PpeAuthenticationProvider'
import { ProdAuthenticationProvider } from "./office-js/auth/ProdAuthenticationProvider";

export const CreateAuthenticationProvider = (environment: AuthEnvironment = AuthEnvironment.PPE) : IAuthenticationProvider => {
    let provider: IAuthenticationProvider = null;
    switch (environment) {
        case AuthEnvironment.PPE:
            provider = new PpeAuthenticationProvider();
            break;
        case AuthEnvironment.Prod:
            provider = new ProdAuthenticationProvider();
            break;
        default:
            throw new Error("Unknown AuthEnvironment: " + environment);
    }

    return provider;
}